/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * * `NoChange` - NO_CHANGE
 * * `Previous` - PREVIOUS
 * * `Assigner` - ASSIGNER
 * * `SpecificUser` - SPECIFIC_USER
 */
export enum ReassignBehavior {
  NO_CHANGE = 'NoChange',
  PREVIOUS = 'Previous',
  ASSIGNER = 'Assigner',
  SPECIFIC_USER = 'SpecificUser',
}
